import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import GoogleMap from 'google-map-react'
import Marker from './MapMarker'
import styles from './map.styl'

export default class Map extends Component {
  static propTypes = {
    onClick: PropTypes.func,
    centerDefault: PropTypes.object,
    center: PropTypes.object,
    location: PropTypes.object,
    zoom: PropTypes.number,
    zoomDefault: PropTypes.number,
    approxAddress: PropTypes.string
  }
  static defaultProps = {
    centerDefault: { lat: 50.07461896310511, lng: 14.426893938476496 },
    zoomDefault: 9
  }

  constructor(props) {
    super(props)
    this.state = {
      isDisabled: true
    }
  }

  handleEnableMap = () => this.setState({ isDisabled: false })

  render() {
    const disabledClass = this.state.isDisabled ? styles.disabled : ''

    return (
      <div
        className={`${styles.map} ${disabledClass}`}
        onClick={() => this.handleEnableMap()}
      >
        <span className={`ico ico--tap ${styles.icoTap}`} />
        <GoogleMap
          bootstrapURLKeys={{
            key: 'AIzaSyCM1wM1pG1A8LNCj295JRv0nW1NOAZc3v8',
            language: 'sk'
          }}
          defaultCenter={this.props.centerDefault}
          center={{ lat: this.props.center.lat, lng: this.props.center.lng }}
          defaultZoom={this.props.zoomDefault}
          zoom={this.props.zoom}
          onClick={this.props.onClick}
          style={{ height: 300, position: 'relative' }}
        >
          <Marker lat={this.props.location.lat} lng={this.props.location.lng} />
        </GoogleMap>
        <div>
          {this.props.approxAddress &&
            <p>
              <FormattedMessage
                id="map.appr_location"
                defaultMessage="Approximate address: "
              />
              {' '}
              {this.props.approxAddress}
            </p>}
        </div>
      </div>
    )
  }
}
